
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getOemDealers = (oemId, withUsers, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Dealers/GetOemDealers/${oemId}/${withUsers}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const DealersService =
{
	getOemDealers
}

export default DealersService
